// firebase.js

import { getDatabase, ref, set, onValue, onDisconnect, serverTimestamp, remove } from "firebase/database";

import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDSUKLStY8Io_7KLvXppex4uuPOLCQ2ypI",
    authDomain: "cog-cms-bf1e7.firebaseapp.com",
    databaseURL: "https://cog-cms-bf1e7-default-rtdb.firebaseio.com",
    projectId: "cog-cms-bf1e7",
    storageBucket: "cog-cms-bf1e7.firebasestorage.app",
    messagingSenderId: "507191290695",
    appId: "1:507191290695:web:a2733b72df4aed59f77a62",
    measurementId: "G-JQQX4Y65GJ"
  };

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
